import axios from "axios";
import store from "@/store";
import router from "@/router";
// import Cookies from "js-cookie";

// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  withCredentials: true, // 允许携带凭据
  headers: {
    "Content-Type": "application/x-www-form-urlencoded", // 'application/json'
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 统一添加请求前缀（/a）
    if (
      !config.noPrefix &&
      !config.url.startsWith(process.env.VUE_APP_API_PREFIX)
    ) {
      config.url = `${process.env.VUE_APP_API_PREFIX}${config.url}`;
    }

    // 设置token
    if (store.state.sessionid) {
      config.headers = {
        "x-token": store.state.sessionid,
        ...config.headers,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // console.log("完整响应:", response);
    // 登录失效情况
    if (response.data && response.data.result == "login") {
      store.dispatch("logout"); // 清除登录状态
      if (router.currentRoute.path !== "/login") {
        router.replace("/login");
      }
      return Promise.reject(new Error("登录已失效，请重新登录"));
    }
    // 统一处理响应数据
    if (
      response.data &&
      response.data.result &&
      response.data.result !== "true"
    ) {
      return Promise.reject(new Error(response.data.message || "Error"));
    }

    return response.data;
  },
  (error) => {
    console.log("error => error.data", error.data);
    // 处理HTTP状态码401未授权
    if (error.response && error.response.status === 401) {
      store.dispatch("logout");
      if (router.currentRoute.path !== "/login") {
        router.replace("/login");
      }
    }

    return Promise.reject(error); // 统一错误处理
  }
);

export default api;
